// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partner-slot[data-v-765ea186] {\n  top: -5px;\n}", ""]);
// Exports
module.exports = exports;
